import IpList from '../../components/IpList';

function Component() {
  return (
    <IpList isTerada={false} />
  );
}

export default Component;
